<template>
    <section>
        <section>
            <form v-on:submit.prevent>
                <div class="input-inline submit product-filter">
                    <input type="search" placeholder="Search products, figure numbers, and keywords" autofocus
                           v-model="query"/>
                    <button type="submit" class="simple"><i class="fa fa-search"></i></button>
                </div>
            </form>
        </section>

        <ais-instant-search
            :search-client="SearchClient"
            :index-name="productsIndex"
            :insights="true"
        >
            <ais-configure :query="query" />
            <div class="browse" v-if="loaded">
                <div class="tree">
                    <ais-hierarchical-menu
                        class="-minimal"
                        :attributes="['categoryLvl0', 'categoryLvl1', 'categoryLvl2', 'categoryLvl3', 'categoryLvl4']"
                        :limit="100"
                    />
                </div>
                <div>
                    <ais-state-results v-slot="{ results: { hits, query } }">
                        <template v-if="hits.length">
                            <ais-hits v-if="hits.length">
                                <template #item="{ item }">
                                    <modal :submittalID="submittalID"
                                        :result="item"
                                    >
                                    </modal>
                                </template>

                            </ais-hits>
                            <ais-pagination />
                        </template>
                        <h4 v-else>
                            No Products found for <i>{{ query }}</i>.
                        </h4>
                    </ais-state-results>

                    <div class="confirm">
                        <div>
                            <router-link :to="{ path: 'information' }" :class="['button alternate simple back']">
                                Information
                            </router-link>
                        </div>

                        <div>
                            <save-button  :saving="saving" @clicked="save"></save-button>
                            <button  @click="next">Next</button>
                        </div>
                    </div>
                </div>
            </div>
            <loading v-else></loading>
        </ais-instant-search>

    </section>
</template>

<script>
    import _ from 'lodash'
    import { SearchClient } from 'vue/AlgoliaSearch'
    import BrowseModal from 'vue/submittal-manager/mechanical/browse/_modal';
    import Pagination from 'vue/common/_pagination';
    import {mapActions} from 'vuex';

    export default {
        data() {
            return {
                SearchClient,
                query: '',
                saving: false,
                loaded: false,
                nextPage: false,
                selectedItems: [],
                productsIndex: window.indexPrefix + 'products',
            }
        },
        components: {
            'modal': BrowseModal,
            'pagination': Pagination,
        },
        methods: {
            save() {
                if (!this.nextPage) {
                    this.saving = true;
                }

                console.log('here')

                try {
                    this.deleteProducts(this.submittalID)
                    .then(() => {
                        try {
                            console.log('now kickoff save products')
                            this.saveProducts(this.submittalID)
                            .then(() => {
                                this.saving = false;

                                if (this.nextPage) {
                                    this.$router.push({'name': 'mechanical-review', 'submittalID': this.submittalID});
                                }
                            })
                            .catch(response => {
                                console.log('caught 101')
                                this.saving = false;
                            });
                        } catch (e) {
                            console.error(e)
                        }
                    })
                    .catch(response => {
                        console.log('caught 107')
                        this.saving = false;
                    });
                } catch (e) {
                    console.error(e)
                }

                console.log('here now')
            },
            next() {
                this.nextPage = true;
                this.save();
            },

            ...mapActions('mechanical', [
                'saveProducts',
                'deleteProducts',
                'getSubmittalInfo',
            ]),

        },
        created() {
            this
            .getSubmittalInfo(this.submittalID)
            .then(() => {
                this.loaded = true;
            });
        },
        props: ['submittalID']
    }
</script>
